export enum VOTemplateType {
    /**来自于BE的VO */
    FromBE,
    /**来自于VO的VO，即VO代理 */
    FromVO,
    /**没有来源的VO，即虚拟VO */
    FromNone,
}